import mockAxios, { AxiosResponse } from 'axios';

import { IItemCommercialTranslationServiceMock } from './itemcommercialtranslation.mock.types';

export const mockItemCommercialTranslationService = (): IItemCommercialTranslationServiceMock => ({
  fetchItemCommercialTranslations: jest.fn(),
  fetchItemCommercialTranslation: jest.fn(),
  createItemCommercialTranslation: jest.fn(),
  updateItemCommercialTranslation: jest.fn(),
  deleteItemCommercialTranslation: jest.fn(),
  uploadItemCommercialTranslationFile: jest.fn(),
  exportItemCommercialTranslations: jest.fn()
});

export const mockItemCommercialTranslationAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
